<!--  -->
<template>
  <div class="coupon-page">
    <div class="header">
      <div class="ht">
        <img class="span-logo" src="../assets/imgs/LOGO_STEFANO_RICCI.svg" alt />
        <!-- <img class="logo" src="../assets/imgs/sr-logo.png" alt /> -->
      </div>
      <div class="hb">
        <div class="input-wrapper">
          <input type="text" v-model="searchValue" placeholder="请输入会员编号" />
          <span class="cancel" v-if="searchValue.length" @click="cancelSearch">取消</span>
        </div>
        <div class="search-btn" @click="serach">搜索</div>
      </div>
    </div>

    <div class="list">
      <div
        class="coupon-box"
        v-if="list.length"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="noData"
        infinite-scroll-distance="0"
      >
        <div class="one-coupon canot-use" v-for="(item, index) in list" :key="index">
          <div class="coupon-top">
            <div class="coupon-left">
              <div class="cl-top">
                <div class="clt-left"  @click="showCouponDetail(index)">
                  <img src="../assets/imgs/sr-logo-gray.png" alt />
                </div>
                <div class="clt-right">
                  <div class="coupon-name ellipsis">{{item.faceValue}}元</div>
                  <div class="coupon-date">核销时间:{{item.useTime}}</div>
                  <div class="coupon-surplus" v-if="item.usageType == 1">
                    满<span class="font-bold">{{item.satisfyMoney}}</span>元可用
                    <span class="use-type">单次使用</span>
                  </div>
                  <div class="coupon-surplus" v-if="item.usageType == 2">
                    核销<span class="font-bold">{{item.money}}</span>元,余额<span class="font-bold">{{item.leftoverValue}}</span>元
                    <span class="use-type">多次使用</span>
                  </div>
                </div>
              </div>
              <div class="cl-bottom" @click="showCouponDetail(index)">
                <span>详细信息</span>
                <span class="arrow" v-if="item.couponShow">︿</span>
                <span class="arrow1" v-else>﹀</span>
              </div>
            </div>
            <div class="coupon-right">
              <img class="status-img" src="../assets/imgs/hexiao.png" alt />
              <!-- <div class="use-now">立即使用</div> -->
              <div class="round"></div>
              <div class="round round2"></div>
            </div>
          </div>
          <div class="coupon-detail" v-if="item.couponShow">
            <p>会员编号:{{item.rpId}}</p>
            <p>优惠券名称: {{item.couponName}}</p>
            <p v-if="item.info != null">使用说明: {{item.info}}</p>
            <p v-if="item.useRange == 1">使用门店：仅限大陆所有门店使用</p>
            <p v-if="item.useRange == 2">
              使用门店：
              <span v-for="(iitem, iindex) in item.couponShops" :key="iindex">
                {{iitem.shopName}}
                <i v-if="iindex+1 != item.couponShops.length">,</i>
              </span>
            </p>
            <!-- <p>优惠券编号: {{item.couponCode}}</p>
            <p v-if="item.getType == 1 || item.getType == 2">系统赠送优惠券</p>
            <p v-if="item.getType == 3">订单消费赠送优惠券</p> -->
          </div>
        </div>
      </div>

      <div class="empty" v-else>
        <img class="empty-img" src="../assets/imgs/sr-logo-gray.png" alt />
        <div>暂无核销记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../assets/js/api.js";
import util from "../assets/js/util.js";
var that;
export default {
  data() {
    return {
      searchValue: "",
      list: [],
      noData: false,
      pageIndex: 0,
      pageSize: 10
    };
  },

  components: {},
  created() {
    that = this;
  },
  mounted() {
    that.loadMore();
  },

  methods: {
    // 获取列表
    loadMore() {
      // 判断是否还有数据
      if (!that.noData) {
        that.pageIndex++;
        that.getData();
      }
    },
    getData() {
      that.noData = true;
      that.$http
        .get(api.clerkWriteRecord, {
          params: {
            token: util.getss("token"),
            pageIndex: that.pageIndex,
            pageSize: that.pageSize,
            searchValue: that.searchValue
          }
        })
        .then(res => {
          if (res.code === util.ERR_OK) {
            that.list = that.list.concat(res.data);
            if (res.data.length < that.pageSize) {
              that.noData = true;
            } else {
              that.noData = false;
            }
          } else {
            that.$toast({ message: res.msg, duration: 2000 });
          }
        });
    },
    // 展示详情
    showCouponDetail(index) {
      that.list[index].couponShow = !that.list[index].couponShow;
    },
    serach() {
      if (that.searchValue === "") {
        that.$toast({ message: "请输入会员编号", duration: 2000 });
        return;
      }
      that.list = [];
      that.pageIndex = 0;
      that.noData = false;
      that.loadMore();
    },
    cancelSearch() {
      that.searchValue = "";
      that.list = [];
      that.pageIndex = 0;
      that.noData = false;
      that.loadMore();
    }
  }
};
</script>
<style lang='stylus' scoped>
.coupon-page {
  width: 100vw;
  height: 100vh;
  background: #eee;
  overflow-y: scroll;

  .header {
    width: 100%;
    background: var(--black);
    z-index: 10;
    position: fixed;
    left: 0;
    top: 0;

    .ht {
      padding: unit(30px) unit(30px) unit(30px);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .span-logo {
        height: unit(50px);
      }

      .logo {
        height: unit(100px);
      }
    }

    .hb {
      width: 100%;
      height: unit(100px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 unit(30px) unit(30px);

      .input-wrapper {
        flex: 1;
        background: #ffffff;
        height: 100%;
        border-radius: unit(40px);
        padding: 0 unit(20px);
        display: flex;
        justify-content: space-between;
        align-items: center;

        input {
          flex: 1;
          border: none;
          outline: none;
          height: unit(40px);
          font-size: unit(30px);
        }

        .cancel {
          font-size: unit(28px);
          color: var(--gray);
          margin-left: unit(20px);
        }
      }

      .search-btn {
        width: unit(120px);
        height: unit(70px);
        background: var(--gold);
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: unit(30px);
        border-radius: unit(30px);
      }
    }
  }

  .list {
    // padding: unit(270px) unit(20px) unit(140px);
    padding: unit(230px) unit(20px) unit(20px);

    .empty {
      width: 100%;
      padding: unit(200px) unit(100px);
      text-align: center;

      .empty-img {
        width: unit(450px);
        margin-bottom: unit(30px);
      }

      div {
        font-size: unit(40px);
        color: #999;
      }
    }

    /* 优惠券盒子 */
    .coupon-box {
      width: 100%;

      .one-coupon {
        width: 100%;
        background: #f6f6f6;
        border-radius: unit(14px);
        margin-bottom: unit(20px);

        .coupon-top {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: stretch;

          .coupon-left {
            flex: 1;
            background: #fff;
            display: flex;
            flex-direction: column;
            border-radius: unit(8px);

            .cl-top {
              padding: unit(10px) 0;
              flex: 1;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .clt-left {
                width: unit(160px);
                height: 100%;
                border-right: 1px dashed #eee;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                  width: unit(120px);
                  height: unit(120px);
                }
              }

              .clt-right {
                flex: 1;
                padding: 0 unit(10px) 0 unit(30px);
                border-radius: unit(10px);

                .coupon-name {
                  width: unit(320px);
                  font-size: unit(38px);
                  font-weight: bold;
                  color: #2a3040;
                  margin-bottom: unit(8px);
                }

                .coupon-date, .coupon-surplus {
                  font-size: unit(22px);
                  color: #787e9a;
                  .font-bold {
                    font-weight: bold;
                    color: #2a3040;
                  }
                }

                .coupon-date {
                  margin-bottom: unit(4px);
                }
              }
            }

            .cl-bottom {
              width: 100%;
              height: unit(45px);
              border-top: 1px solid #eee;
              padding: 0 unit(20px) 0 unit(28px);
              display: flex;
              justify-content: space-between;
              align-items: center;

              span {
                font-size: unit(22px);
                color: #a9a9a9;
              }

              .arrow {
                margin-top: unit(-14px);
              }
            }
          }

          /* 右侧立即使用 */
          .coupon-right {
            width: unit(197px);
            height: unit(203px);
            background: var(--gold);
            position: relative;
            border-radius: unit(8px);

            .use-now {
              border-radius: unit(24px);
              border: unit(2px) solid #fff;
              width: unit(156px);
              height: unit(50px);
              font-size: unit(24px);
              color: #fff;
              span-align: center;
              line-height: unit(50px);
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            .status-img {
              width: unit(140px);
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            .round {
              width: unit(26px);
              height: unit(26px);
              background: #eee;
              border-radius: 50%;
              position: absolute;
              left: unit(-13px);
              bottom: unit(-13px);
            }

            .round2 {
              top: unit(-13px);
            }
          }
        }

        /* 下方详情 */
        .coupon-detail {
          padding: unit(22px) unit(22px) unit(12px);
          background: #f6f6f6;
          font-size: unit(22px);
          color: #a9a9a9;
          line-height: unit(32px);
          border-bottom-left-radius: unit(8px);
          border-bottom-right-radius: unit(8px);
          position: relative;
        }
      }

      .canot-use {
        .clt-right {
          div, span {
            color: #a9a9a9 !important;
          }
        }

        .coupon-right {
          background: #ccc !important;
        }
      }
    }
  }
}
</style>